import { implementsFunction } from "@thi.ng/checks/implements-function";
import { CloseMode } from "./api.js";
const isSubscribable = (x) => implementsFunction(x, "subscribe");
const isFirstOrLastInput = (mode, num) => mode === CloseMode.FIRST || mode === CloseMode.LAST && !num;
export {
  isFirstOrLastInput,
  isSubscribable
};
